import * as React from 'react';
import {Navigate, useParams} from "react-router-dom";

type Props = {};
const RedirectCycleIndex = (props: Props) => {
    const routerParams = useParams();
    // return <Navigate to={`/wbs/${routerParams.wbsId}/versions/${routerParams.wbsVersionId}`} replace/>;
    return <Navigate to={`/erp/paymentcycles/${routerParams.id}/raw_data_file_vault`} replace/>;
};

export default RedirectCycleIndex;